<script setup lang="ts">

import {NavigationItem} from "@/types";
import {router} from "@inertiajs/vue3";
import {route} from "ziggy-js";

interface Props {
    items: Array<NavigationItem>,
}

const props = defineProps<Props>()

const goToRoute = (name: string) => {
    router.visit(route(name,))
}

const isRouteActive = (name: string) => {
    return route().current(name)
}
</script>

<template>
    <v-list>
        <div
            v-for="(item, key) in props.items"
            :key="key"
        >
            <v-divider
                v-if="item.route === undefined"
                class="my-1"
            />
            <v-list-subheader
                v-if="item.route === undefined"
                class="font-weight-bold text-caption"
                :title="item.label"
            />
            <v-list-item
                v-else
                density="compact"
                :slim="true"
                rounded="lg"
                :link="true"
                :active="isRouteActive(item.route)"
                :prepend-icon="item.icon"
                class="my-1"
                active-class="is-active"
                @click="goToRoute(item.route)"
            >
                <template #prepend>
                    <v-icon size="20">
                        {{ item.icon }}
                    </v-icon>
                </template>
                <v-list-item-title
                    class="text-body-2"
                    :class="isRouteActive(item.route) ? 'font-weight-bold' : null"
                >
                    {{ item.label }}
                </v-list-item-title>
            </v-list-item>
        </div>
    </v-list>
</template>

<style scoped>
:deep(.v-list-subheader) {
    max-height: 20px !important;
}
</style>
